export default __webpack_public_path__ + "static/media/p-44.331483dc.svg";